import { createFileRoute } from '@tanstack/react-router'
import { ServiceBoardPage } from '../../../features/service/board-page'
import { serviceBoardSearchSchema } from '../../../features/service/search'

export const Route = createFileRoute('/_app/service/schedule')({
  staticData: { crumb: 'serviceSchedule' },
  validateSearch: serviceBoardSearchSchema,
  component: ServiceBoardPage,
})
